import React from "react";

import "./YogaHeader.css";

function YogaHeader() {
  return (
    <div className="yoga_header_page">
      <div className="yoga_header_container">
        <h1>Yoga</h1>
      </div>
    </div>
  );
}

export default YogaHeader;
